import React from "react";

const FileUplaodPreview = ({ meta, fileWithMeta, customStatus}) => {
  const { name, percent = 0, status, previewUrl } = meta;

  const removeFile = () => {
    fileWithMeta.remove();
  };

  const renderStatus = () => {
   let ret = status;
   if(status==="uploading") ret =  "Uploading...";
   if(status==="done")  ret = "Verification in process";
   if(status==="error_upload")  ret = "Error";
   if(status=== "error_validation")  ret = 'Error';
   if(customStatus === "verified") ret ="Upload Complete";
   return ret;
   
  };

  return (
    <div style={styles.container}>
      {/* Thumbnail */}
      {previewUrl && (
        <img src={previewUrl} alt={name} style={styles.thumbnail} />
      )}

      <div style={styles.details}>
        {/* File Name */}
        <div style={styles.filename}>{name}</div>

        {/* Progress Bar */}
        <div style={styles.progressWrapper}>
          <div
            style={{
              ...styles.progressBar,
              width: `${percent}%`,
            }}
          />
        </div>

        {/* Status */}
        <div style={styles.status}>{renderStatus()}</div>
      </div>

      {/*<button onClick={removeFile} style={styles.removeBtn}>
        ✕
      </button>*/}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #eee",
    padding: 10,
    marginTop: 10,
    borderRadius: 8,
    width: '100%',
  },
  thumbnail: {
    width: 60,
    height: 60,
    objectFit: "cover",
    borderRadius: 6,
    marginRight: 10,
  },
  details: {
    flex: 1,
  },
  filename: {
    fontWeight: 600,
    marginBottom: 4,
  },
  progressWrapper: {
    width: "100%",
    height: 6,
    background: "#eee",
    borderRadius: 4,
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    background: "#4caf50",
  },
  status: {
    fontSize: 12,
    marginTop: 4,
  },
  removeBtn: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 16,
  },
};

export default FileUplaodPreview;